export const RESOURCE_TYPE_NEW_ISSUE_VIEW_LOCK_IN_STATUS = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';
